import { getRequest } from '@/core';
import { locations } from '@/requests';

export default async function getLocationByIdRequest(id) {
	let url = locations.getByIdPath(id);
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
